@if (rail.visible()) {
  <aside
    class="admin-utility-rail"
    [class.admin-utility-rail--expanded]="rail.expanded()"
    [attr.aria-label]="'header.utilityNav' | translate"
  >
    <button
      type="button"
      class="admin-utility-rail__toggle"
      [attr.aria-expanded]="rail.expanded()"
      [attr.aria-label]="
        (rail.expanded() ? 'header.utilityRail.collapse' : 'header.utilityRail.expand') | translate
      "
      (click)="toggle()"
    >
      <mat-icon>{{ rail.expanded() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
    </button>

    @if (rail.expanded()) {
      <div class="admin-utility-rail__tools" role="toolbar" [attr.aria-label]="'header.utilityNav' | translate">
        @for (tool of rail.tools(); track tool.id) {
          <button
            type="button"
            class="admin-utility-rail__tool"
            [attr.aria-label]="tool.labelKey | translate"
            [matTooltip]="tool.labelKey | translate"
            matTooltipPosition="left"
            (click)="openTool(tool)"
          >
            <i class="iconify admin-utility-rail__tool-icon" [attr.data-icon]="tool.icon"></i>
          </button>
        }
      </div>
    }
  </aside>
}
